// extracted by mini-css-extract-plugin
export default {"addressSection":"eS-z","disabled":"fS-z","sectionButtons":"gS-z","logo":"hS-z"};